import {
  AutocompleteArrayInput,
  AutocompleteInput,
  ReferenceArrayInput,
  ReferenceInput,
  TextInput,
} from "ra-ui-materialui";
import { useEffect, useState } from "react";
import { FormDataConsumer, required, useDataProvider } from "react-admin";
import { useGetTree } from "@react-admin/ra-tree";
import { EmployeeServicePath, TREE } from "utils/constants";
import { useController, useFormContext } from "react-hook-form";

import { useLocation } from "react-router";
import TreeSelect from "features/TreeSelect";
import { employeeRequests } from "api/employeeApi";
import { administrationRequests } from "api/administrationApi";

const TreeNodeForm = () => {
  const location = useLocation();

  const [displayValues, setDisplayValues] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [nodes, setNodes] = useState([]);
  const { control, watch } = useFormContext();
  const rowStructuralUnit = watch("structuralUnitId");
  const alternateParentId = watch("alternateParentId");
  const reference = `${EmployeeServicePath}${TREE}`;
  const { data: treeData } = useGetTree(reference + `?StructuralUnitId=${rowStructuralUnit}`);
  const dataProvider = useDataProvider();

  const { field } = useController({
    name: "alternateParentId",
    control,
  });
  const open = Boolean(anchorEl);

  const findNodeName = (nodes, id) => {
    if (id === undefined || id === null || nodes === undefined) return "";
    const idStr = String(id);
    for (const node of nodes) {
      if (!node) continue;
      if (String(node.id) === idStr) return node.name || "";
      if (node.children) {
        const found = findNodeName(node.children, id);
        if (found) return found;
      }
    }
    return "";
  };

  useEffect(() => {
    let mounted = true;
    dataProvider
      .getList(reference, {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "id", order: "ASC" },
      })
      .then(({ data: fetched }) => {
        if (!mounted) return;
        setNodes(fetched);

        const nameFromFetched = findNodeName(fetched, alternateParentId);
        setDisplayValues(nameFromFetched || "");
      })
      .catch(err => {
        // optional: handle or log error
        console.error("Failed to load tree nodes", err);
      });

    return () => {
      mounted = false;
    };
  }, [location, rowStructuralUnit, alternateParentId, dataProvider, reference]);

  useEffect(() => {
    const name = findNodeName(nodes, alternateParentId);
    setDisplayValues(name || "");
  }, [nodes, alternateParentId]);

  const handleSelect = selectedId => {
    field.onChange(selectedId);
    const name = findNodeName(nodes, selectedId);
    setDisplayValues(name || "");
    setAnchorEl(null);
  };

  return (
    <FormDataConsumer>
      {({ formData, scopedFormData, ...rest }) => (
        <>
          <TextInput
            label="Заглавие"
            source="name"
            validate={required()}
            isRequired
            fullWidth
          />

          <ReferenceInput
            source="structuralUnitId"
            filter={{ filterByUser: true }}
            reference={administrationRequests.getStructuralUnitsSelect()}
          >
            <AutocompleteInput
              label="Факултет"
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
              emptyText="Всички"
              validate={required()}
              onChange={e => {
                if (!e) return;
                handleSelect(null);
              }}
              isRequired
            />
          </ReferenceInput>

          {formData?.structuralUnitId ? (
            <ReferenceInput
              source="departmentId"
              filter={{ StructuralUnitId: formData?.structuralUnitId }}
              reference={administrationRequests.getDepartmentsSelect()}
            >
              <AutocompleteInput
                label="Катедра"
                filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                emptyText="Всички"
              />
            </ReferenceInput>
          ) : null}
          <ReferenceArrayInput
            source="positionIds"
            filter={{ filterByUser: true }}
            reference={employeeRequests.getPositionsSelect()}
          >
            <AutocompleteArrayInput
              label="Позиция"
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            />
          </ReferenceArrayInput>
          {rowStructuralUnit ? (
            <TreeSelect
              label="Втори родител"
              open={open}
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              handleSelect={handleSelect}
              data={treeData || nodes}
              displayValues={displayValues}
              source={"alternateParentId"}
            />
          ) : null}
        </>
      )}
    </FormDataConsumer>
  );
};

export default TreeNodeForm;
